import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import {Link, NavLink, Outlet, useNavigate} from "react-router";
import {useAuth} from "../auth/AuthContext";
import {ThemeToggle} from "../theme/ThemeToggle";

// Every page: the navbar, the page, the footer. Public and admin pages share it (and the login screen).
export function SiteLayout() {
    const {user, isAdmin, logout} = useAuth();
    const navigate = useNavigate();

    const signOut = async () => {
        await logout();
        navigate('/');
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            <Navbar expand="md" className="bg-body-tertiary border-bottom" collapseOnSelect>
                <Container>
                    <Navbar.Brand as={Link} to="/">
                        <img src="/favicon.svg" alt="" width="24" height="24" className="me-2 align-text-top"/>
                        Tristar Advanced Software
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="main-nav"/>
                    <Navbar.Collapse id="main-nav">
                        <Nav className="me-auto">
                            <Nav.Link as={NavLink} to="/" end>Home</Nav.Link>
                            {user && <Nav.Link as={NavLink} to="/account/licenses">My licences</Nav.Link>}
                            {isAdmin && <Nav.Link as={NavLink} to="/admin">Administration</Nav.Link>}
                        </Nav>
                        <Nav>
                            <ThemeToggle/>
                            {user ? (
                                <NavDropdown align="end" id="account-menu" title={<><i className="bi bi-person-circle me-1"></i>{user.displayName || user.username}</>}>
                                    <NavDropdown.Item as={Link} to="/account/profile">Profile</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/account/licenses">My licences</NavDropdown.Item>
                                    <NavDropdown.Divider/>
                                    <NavDropdown.Item onClick={signOut}>Sign out</NavDropdown.Item>
                                </NavDropdown>
                            ) : (
                                <Nav.Link as={NavLink} to="/login">Sign in</Nav.Link>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Container as="main" className="py-4 flex-grow-1">
                <Outlet/>
            </Container>
            <footer className="border-top py-3 text-body-secondary small">
                <Container>© {new Date().getFullYear()} Tristar Advanced Software</Container>
            </footer>
        </div>
    );
}
